<template>
    <div class="list-container">
        <editable-list v-if="data"
                       :data="data"
                       :template="template"
                       @save-parent="save"/>
    </div>
</template>

<script>
	import InfoBlockService from "../services/InfoBlockService";
	import ListMixin from "../mixins/ListMixin";

	export default {
		name: "Frontpage",
		mixins: [ListMixin],
		data() {
			return {
				template: {
					_id: "",
					title: "",
					lang: 0,
					contents: {
						link: "",
						details: ""
					}
				},
                backend: InfoBlockService
			};
		}
	}
</script>

<style scoped lang="scss">
    .list-container {
        display: flex;
        position: relative;
        flex-direction: row;
        height: 100vh;
        overflow-y: hidden;
    }
</style>